import { defineComponent as _defineComponent } from 'vue'
import { LotStatus } from "@/enums/LotStatus";
  import { redirectWithoutRouter } from "@/helpers/redirectWithoutRouter";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderControlsButtons',
  props: {
    lot: {
      type: Object,
      required: true,
    },
    isInitialHoldDisabled: {
      type: Boolean,
      required: true,
    },
    landOptionsAvailable: {
      type: Boolean,
      required: true,
    },
    isEmbedded: {
      type: Boolean,
      required: true,
    },
    buttonsDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideRequestHold: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["contact", "hold", "requestQuote", "reserve"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(680);

  const emits = __emit;
  const props = __props;
  const hold = () => {
    if (props.buttonsDisabled || props.hideRequestHold) return;

    emits("hold", props.lot);
  };

  const toContact = () => {
    emits("contact");
  };

  const reserve = () => {
    emits("reserve");
  };

  const requestQuoteEmit = () => {
    if (!props.buttonsDisabled) {
      emits("requestQuote");
    }
  };

  const onRequestQuote = () => {
    if (props.isEmbedded) {
      redirectWithoutRouter(
        `/builder/estate/${props.lot.estateId}/lot/${props.lot._id}`,
        "_blank"
      );
      return;
    }

    requestQuoteEmit();
  };

const __returned__ = { isDesktop, emits, props, hold, toContact, reserve, requestQuoteEmit, onRequestQuote, get LotStatus() { return LotStatus }, get redirectWithoutRouter() { return redirectWithoutRouter }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})